export default {
  title: "My exhibitions",
  archivedEvents: "Archived",

  loadingMessage: "Loading...",
  noEventsMessage: "You have no exhibitions available",
  popupOrderQuestion: "Are you sure you want to cancel this order?",
  popupClassicDelete: "Delete",
  popupClassicCancel: "Cancel",
  popupOrderDelete: "Yes",
  popupOrderCancel: "No",
  inviteInputPlaceholder: "Enter a participant code"
};
